export default "__VITE_ASSET__9T5$V2KX__"